import { LineChart } from '../../Common/Charts/LineChart';
import { useProductionTemporalChartsDataContext } from './hooks/useProductionTemporalChartsDataContext';

const MONTH_LABELS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

const LINE_COLORS = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'];

export const ProductionMonthlySeries = () => {
    const { chartData } = useProductionTemporalChartsDataContext();

    const serieMensal = chartData?.monthlySeries || {};
    const years = Object.keys(serieMensal);

    const monthsSet = new Set();
    years.forEach((year) => {
        Object.keys(serieMensal[year] || {}).forEach((month) => monthsSet.add(month));
    });
    const months = Array.from(monthsSet).sort();

    const subtitles = months.map((month) => MONTH_LABELS[Number(month) - 1] || month);
    const values = years.map((year) => months.map((month) => serieMensal[year]?.[month] ?? 0));

    return (
        <LineChart
            title={'Série Histórica Mensal por Ano'}
            category={years}
            values={values}
            subtitles={subtitles}
            colors={LINE_COLORS}
        />
    );
};
